import React, { useState, useEffect } from "react";
import { config } from "../config/config";

const ActividadForm = ({ onSubmit, initialData, resetForm }) => {
    // Estado para almacenar los datos del formulario
    const [formData, setFormData] = useState({
        materia_id: "",
        nombre_actividad: "",
        tipo_actividad: "tarea",
        fecha: "",
        ponderacion: "",
        periodo:"1",
    });

    // Estado para almacenar la lista de materias
    const [materias, setMaterias] = useState([]);

    // Obtener las materias desde la API
    useEffect(() => {
        fetch(`${config.apiUrl}/materias`)
            .then((res) => res.json())
            .then((data) => setMaterias(data))
            .catch(console.error);
    }, []);

    // Efecto para cargar datos iniciales o resetear el formulario
    useEffect(() => {
        if (initialData) {
            setFormData(initialData);
        } else if (resetForm) {
            setFormData({
                materia_id: "",
                nombre_actividad: "",
                tipo_actividad: "tarea",
                fecha: "",
                ponderacion: "",
                periodo:"",
            });
        }
    }, [initialData, resetForm]);

    // Manejar cambios en los campos del formulario
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    // Manejar el envío del formulario
    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(formData);
    };

    return (
        <div className="container mt-5">
            <h2 className="mb-4">Formulario de Actividad</h2>
            <form onSubmit={handleSubmit} className="p-3 border rounded bg-light">
                <div className="row">
                    {/* Materia ID */}
                    <div className="col-md-6 mb-3">
                        <label htmlFor="materia_id">Materia:</label>
                        <select
                            id="materia_id"
                            name="materia_id"
                            className="form-control"
                            value={formData.materia_id}
                            onChange={handleChange}
                            required
                        >
                            <option value="">Seleccione una materia</option>
                            {materias.map((materia) => (
                                <option key={materia.materia_id} value={materia.materia_id}>
                                    {materia.nombre_materia} ({materia.nombre_grado})
                                </option>
                            ))}
                        </select>
                    </div>
                    {/* Nombre de la Actividad */}
                    <div className="col-md-6 mb-3">
                        <label htmlFor="nombre_actividad">Nombre de la Actividad:</label>
                        <input
                            type="text"
                            id="nombre_actividad"
                            name="nombre_actividad"
                            className="form-control"
                            value={formData.nombre_actividad}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    {/* Tipo de Actividad */}
                    <div className="col-md-6 mb-3">
                        <label htmlFor="tipo_actividad">Tipo de Actividad:</label>
                        <select
                            id="tipo_actividad"
                            name="tipo_actividad"
                            className="form-control"
                            value={formData.tipo_actividad}
                            onChange={handleChange}
                        >
                            <option value="tarea">Tarea</option>
                            <option value="examen">Examen</option>
                        </select>
                    </div>
                    {/* Fecha */}
                    <div className="col-md-6 mb-3">
                        <label htmlFor="fecha">Fecha:</label>
                        <input
                            type="date"
                            id="fecha"
                            name="fecha"
                            className="form-control"
                            value={formData.fecha}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    {/* Ponderación */}
                    <div className="col-md-6 mb-3">
                        <label htmlFor="ponderacion">Ponderación:</label>
                        <input
                            type="number"
                            id="ponderacion"
                            name="ponderacion"
                            className="form-control"
                            step="0.01"
                            value={formData.ponderacion}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    {/* Bimestre */}
                    <div className="col-md-6 mb-3">
                        <label htmlFor="periodo">Bimestre:</label>
                        <select
                            id="periodo"
                            name="periodo"
                            className="form-control"
                            value={formData.periodo}
                            onChange={handleChange}
                        >
                            <option value="1">1</option>
                            <option value="2">2</option>
                            <option value="3">3</option>
                            <option value="4">4</option>
                        </select>
                    </div>
                </div>
                {/* Botón para enviar */}
                <div className="text-center mt-3">
                    <button type="submit" className="btn btn-primary">Guardar</button>
                </div>
            </form>
        </div>    );
};

export default ActividadForm;